import React, { useEffect, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
export function App() {
  // Meta Pixel
  useEffect(() => {
    if ((window as any).fbq) return;
    const f = window as any;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '1415475363502446');
    f.fbq('track', 'PageView');
  }, []);
  // Google Analytics (gtag.js)
  useEffect(() => {
    const w = window as any;
    if (w.gtag) return;
    // 1. Initialize dataLayer BEFORE loading the script
    w.dataLayer = w.dataLayer || [];
    // 2. Define gtag exactly as Google specifies (using arguments object)
    function gtag() {
      w.dataLayer.push(arguments);
    }
    w.gtag = gtag;
    (gtag as any)('js', new Date());
    (gtag as any)('config', 'G-7NJ4P109PH');
    // 4. Load the gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-7NJ4P109PH';
    document.head.appendChild(script);
  }, []);
  // Dynamic tab title
  useEffect(() => {
    const ACTIVE_TITLE = 'Arma tu home studio desde cero';
    const HIDDEN_TITLE = '🎧 Cambia tu música ahora!';
    document.title = ACTIVE_TITLE;
    const handleVisibilityChange = () => {
      document.title = document.hidden ? HIDDEN_TITLE : ACTIVE_TITLE;
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return <LandingPage data-id="element-0" />;
}